import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = ["type", "disabled"]
const _hoisted_2 = {
  key: 0,
  class: "animate-spin h-4 w-4 shrink-0",
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24",
  "aria-hidden": "true"
}

import { computed } from "vue";

const base =
  "inline-flex items-center justify-center gap-2 font-semibold rounded-xl transition-colors focus:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 disabled:opacity-50 disabled:cursor-not-allowed";


export default /*@__PURE__*/_defineComponent({
  __name: 'AdminButton',
  props: {
    variant: { default: "primary" },
    size: { default: "md" },
    loading: { type: Boolean, default: false },
    disabled: { type: Boolean, default: false },
    block: { type: Boolean, default: false },
    type: { default: "button" }
  },
  emits: ["click"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

const isDisabled = computed(() => props.disabled || props.loading);

const sizeClass = computed(() => {
  switch (props.size) {
    case "sm":
      return "px-3 py-2 text-sm";
    case "lg":
      return "px-8 py-3.5 text-base";
    default:
      return "px-5 py-2.5 text-sm";
  }
});

const variantClass = computed(() => {
  switch (props.variant) {
    case "secondary":
      return "text-slate-700 bg-white border-2 border-slate-200 hover:bg-slate-50 focus-visible:ring-slate-400";
    case "danger":
      return "text-white bg-red-600 hover:bg-red-700 focus-visible:ring-red-500 shadow-sm";
    case "ghost":
      return "text-slate-600 bg-transparent hover:bg-slate-100 focus-visible:ring-slate-400";
    case "info":
      return "text-white bg-blue-600 hover:bg-blue-700 focus-visible:ring-blue-500 shadow-sm";
    case "success":
      return "text-white bg-emerald-600 hover:bg-emerald-700 focus-visible:ring-emerald-500 shadow-sm";
    default:
      return "text-white bg-gradient-to-r from-red-600 to-red-700 hover:from-red-700 hover:to-red-800 focus-visible:ring-red-500 shadow-sm";
  }
});

const widthClass = computed(() => (props.block ? "w-full" : ""));

const onClick = (e: MouseEvent) => {
  if (isDisabled.value) return;
  emit("click", e);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("button", {
    type: __props.type,
    disabled: isDisabled.value,
    class: _normalizeClass([base, sizeClass.value, variantClass.value, widthClass.value]),
    onClick: onClick
  }, [
    (__props.loading)
      ? (_openBlock(), _createElementBlock("svg", _hoisted_2, [...(_cache[0] || (_cache[0] = [
          _createElementVNode("circle", {
            class: "opacity-25",
            cx: "12",
            cy: "12",
            r: "10",
            stroke: "currentColor",
            "stroke-width": "4"
          }, null, -1),
          _createElementVNode("path", {
            class: "opacity-75",
            fill: "currentColor",
            d: "M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
          }, null, -1)
        ]))]))
      : _createCommentVNode("", true),
    _renderSlot(_ctx.$slots, "default")
  ], 10, _hoisted_1))
}
}

})